<div id="user-profile-base-data-wrapper">
  <div>
    <div class="card-wrapper">
      <div class="card">
        <div class="card-header">
          <div class="title-row">
            <div class="title k-d-flex k-align-items-center">
              <h2 class="mb-0">Profil</h2>
            </div>
          </div>
        </div>

        <div class="card-body">
          <app-user-profile-personal-data />
        </div>
      </div>
    </div>

    <div class="card-wrapper k-mt-10">
      <div class="card">
        <div class="card-header">
          <div class="title-row">
            <div class="title k-d-flex k-align-items-center">
              <h2 class="mb-0">Beschäftigung</h2>
            </div>
          </div>
        </div>

        <div class="card-body">
          <app-user-profile-employment-data />
        </div>
      </div>
    </div>

    <div class="card-wrapper k-mt-10">
      <div class="card">
        <div class="card-header">
          <div class="title-row">
            <div class="title k-d-flex k-align-items-center">
              <h2 class="mb-0">Gehalt</h2>
            </div>
          </div>
        </div>

        <div class="card-body">
          <app-user-profile-salary-data />
        </div>
      </div>
    </div>
  </div>

  <aside id="quicklinks" class="k-pl-10 k-pos-sticky">
    <div class="card-wrapper">
      <div class="card">
        <div class="card-header">
          <div class="title-row">
            <div class="title k-d-flex k-align-items-center">
              <h2 class="mb-0">Inhalt</h2>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div id="link-list">
            <a [routerLink]="" class="item k-d-block k-pos-relative active">Persönliche Daten</a>
            <a [routerLink]="" class="item k-d-block k-pos-relative">Beschäftigung</a>
            <a [routerLink]="" class="item k-d-block k-pos-relative">Gehalt</a>
          </div>
        </div>
      </div>
    </div>
  </aside>
</div>

<app-page-footer>
  <!-- Local reference is needed -->
  <ng-template #controlBarTemplate>
    <button kendoButton (click)="cancel()" themeColor="secondary" size="large" class="k-mr-10">
      Abbrechen
    </button>
    <button
      class="ms-3"
      kendoButton
      themeColor="base"
      size="large"
      [disabled]="false"
      (click)="onSubmit()"
    >
      <span class="custom-symbol save k-mr-3"></span>
      <span>
        {{ true ? "Aktualisieren" : "Speichern" }}
      </span>
    </button>
  </ng-template>
</app-page-footer>
